import React, { useMemo } from 'react';
import _ from 'lodash';
import { Text } from '../Text';
import { StepperInput } from '../../fields';
import { useLocalize } from '../../../hooks';
export const StepperField = ({ field, form, id, options, defaultLabelId, disabledOptions, onChanged, onChangedAndSetValue: _onChangedAndSetValue, // deprecated, kept for backward compatibility
errorAfterSubmit, }) => {
    const { values, errors, touched, submitCount, setFieldValue } = form;
    const { getFieldTranslationId } = useLocalize();
    const value = _.get(values, id);
    const error = _.get(touched, id) ? _.get(errors, id) : undefined;
    const translationId = getFieldTranslationId({ id, defaultLabelId });
    // showError will only show errors when field is touched or after submit if errorAfterSubmit is true
    const showError = errorAfterSubmit ? !!submitCount : !!_.get(touched, id);
    const buttonOptions = useMemo(() => _.map(options, o => {
        return {
            value: _.isString(o) ? o : o.value,
            label: _.isString(o) ? React.createElement(Text, { id: `${translationId}.${o}`, type: "field" }) : o.label,
            disabled: _.isString(o) ? _.includes(disabledOptions, o) : !!o.disabled,
        };
    }), [options, translationId, disabledOptions]);
    const onChange = (_e, option) => {
        // Always update Formik immediately so blur-triggered validation sees the new value.
        setFieldValue(id, option);
        if (onChanged) {
            onChanged(option);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StepperInput, { name: id, options: buttonOptions, value: value, error: error, onblur: field.onBlur, onchange: onChange }),
        error && showError && (React.createElement("span", { className: "error" },
            React.createElement(Text, { id: id, textKey: error, type: 'error' })))));
};
//# sourceMappingURL=Stepper.js.map